const publicRouters = [
    {
        //h5分享页
        path:"/app",
        component: () => import('@/pages/Mobile/PublicRouter/App/index.vue'),
        meta:{
            title:"分享",
            requiresAuth:false,
        },
        children:[
            {
                path: 'h5',
                component: () => import('@/pages/Mobile/PublicRouter/App/H5/index.vue'),
                meta:{
                    title:"登录",
                },
                children:[
                    {  
                        path: 'aidraw',
                        component: () => import('@/pages/Mobile/PublicRouter/App/components/aidraw.vue'),
                        meta:{
                            title:"分享",
                        },
                    }
                ]
            },
        ]
    },
    {
        path: '/v1',
        component: () => import('@/pages/Mobile/PublicRouter/v1/index.vue'),
        redirect: '/v1/sharetopchat',
        meta:{
            title:"分享",
            requiresAuth:false,
        },
        children:[
            {
                path: 'sharetopchat',
                component: () => import('@/pages/Mobile/PublicRouter/v1/Sharetopchat/ShareTopchat'),
                 meta:{title:'分享'},
            },
        ]
    },
    {
        path: '/privacy',
        component: () => import('@/pages/Mobile/PublicRouter/Privacy.vue'),
        meta:{title:"隐私协议"},
    },
    // {
    //     path:'/test',
    //     component: () => import('@/pages/test.vue'),
    //     meta:{
    //         title:"测试"
    //     }
    // },
    { path: '*', redirect: '/' },
]

export default publicRouters;